export default "__VITE_ASSET__CahaoKTO__"